<template>
  <v-container class="pa-0">
    <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
      <page-header-title :title="$t('persons.title')"></page-header-title>

      <v-spacer></v-spacer>

      <router-link :to="BACKEND_URL + '/persons/create'" v-if="$can('person-create')">
        <action-button type="new" />
      </router-link>

      <action-button type="filter" @click="show_filter = !show_filter" />
    </v-app-bar>

    <v-expansion-panels :value="0" class="cstm-filter mb-3 elevation-0" v-if="show_filter" readonly>
      <v-expansion-panel>
        <v-expansion-panel-header hide-actions>
          {{ $t("global.filter") }}
        </v-expansion-panel-header>
        <v-expansion-panel-content class="elevation-1">
          <v-form ref="form" @submit.prevent="filter">
            <v-container grid-list-md>
              <v-layout row wrap>
                <v-flex md6>
                  <v-text-field
                    :label="$t('persons.first_name')"
                    v-model="search_params.first_name"
                    autocomplete="new-password"
                  ></v-text-field>
                </v-flex>

                <v-flex md6>
                  <v-text-field
                    :label="$t('persons.last_name')"
                    v-model="search_params.last_name"
                    autocomplete="new-password"
                  ></v-text-field>
                </v-flex>

                <v-flex md6>
                  <v-text-field :label="$t('persons.email')" v-model="search_params.email" autocomplete="new-password"></v-text-field>
                </v-flex>

                <v-flex md6>
                  <v-autocomplete
                    v-model="search_params.organisation_id"
                    :items="organisations"
                    item-text="name"
                    item-value="id"
                    :label="$t('organisations.title')"
                    autocomplete="new-password"
                  ></v-autocomplete>
                </v-flex>

                <v-flex md12>
                  <action-button type="filter" @click="filter" small />
                  <action-button type="reset" @click="reset" small />
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <v-card>
      <v-card-text>
        <v-flex md12>
          <v-data-table
            :headers="headers"
            :items="persons"
            :options.sync="pagination"
            :footer-props="{
              showFirstLastPage: true,
              'items-per-page-options': this.DATATABLE_ITEM_PER_PAGE_OPTIONS,
              'items-per-page-all-text': $t('global.items_per_page_all_text'),
              'items-per-page-text': $t('global.items_per_page_text'),
              'page-text': $t('global.page_text')
            }"
            :server-items-length="total"
            :loading="show_loading"
            :must-sort="true"
          >
            <template v-slot:item.email="{ item }">
              {{ item.user.email }}
            </template>

            <template v-slot:item.organisation_id="{ item }">
              {{ item.organisation.name }}
            </template>

            <template v-slot:item.actions="{ item }">
              <router-link :to="{ path: BACKEND_URL + '/persons/view/' + item.id, props: { id: item.id } }" v-if="$can('person-access')">
                <action-button type="view" :icon_only="true" small />
              </router-link>

              <router-link :to="{ path: BACKEND_URL + '/persons/edit/' + item.id, props: { id: item.id } }" v-if="$can('person-edit')">
                <action-button type="edit" :icon_only="true" small />
              </router-link>

              <action-button type="delete" @click="del(item.id)" v-if="$can('person-delete')" :icon_only="true" small />
            </template>
          </v-data-table>
        </v-flex>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "UserList",

  data() {
    return {
      url: "",
      persons: [],
      organisations: [],
      total: 0,
      show_loading: false,
      show_filter: false,
      refresh: false,
      pagination: {
        page: this.$getLocalStorage("__page_Person_List", "page"),
        itemsPerPage: this.$getSetting("rows_per_page"),
        sortBy: ["id"],
        sortDesc: [false]
      },
      search_params: {}
    }
  },

  computed: {
    headers: {
      get() {
        return [
          { text: this.$t("persons.first_name"), value: "first_name" },
          { text: this.$t("persons.middle_name"), value: "middle_name" },
          { text: this.$t("persons.last_name"), value: "last_name" },
          { text: this.$t("persons.email"), value: "email" },
          { text: this.$t("organisations.title"), value: "organisation_id" },
          { text: this.$t("persons.mobile"), value: "mobile" },
          { text: this.$t("global.actions"), value: "actions", width: "20%" }
        ]
      }
    }
  },

  watch: {
    refresh: {
      handler() {
        if (this.refresh) {
          this.list()
        }
      }
    },
    pagination: {
      handler(newVal, oldVal) {
        if (!_.isEqual(newVal, oldVal)) {
          if (
            _.has(newVal, "sortBy") &&
            _.has(newVal, "sortDesc") &&
            _.has(oldVal, "sortBy") &&
            _.has(oldVal, "sortDesc") &&
            (!_.isEqual(newVal.sortBy, oldVal.sortBy) || !_.isEqual(newVal.sortDesc, oldVal.sortDesc))
          ) {
            let obj = {
              sortBy: this.pagination.sortBy,
              sortDesc: this.pagination.sortDesc
            }
            localStorage.setItem("__sort_Person_List", JSON.stringify(obj))
          }

          if (_.has(newVal, "page") && !_.isEqual(newVal.page, oldVal.page)) {
            localStorage.setItem("__page_Person_List", newVal.page)
          }

          this.refresh = true
        }
      }
    }
  },

  mounted() {
    this.url = this.API_URL + "persons"
  },

  created() {
    // Get Organisations
    axios.get(this.API_URL + "organisations?show_all").then((res) => {
      this.organisations = res.data.data
    })
  },

  methods: {
    list(url) {
      this.show_loading = true

      let localFilter = localStorage.getItem("__filter_Person_List")
      if (localFilter !== null) {
        localFilter = JSON.parse(localFilter)
        this.search_params = localFilter
      }

      let localSort = localStorage.getItem("__sort_Person_List")
      if (localSort !== null) {
        localSort = JSON.parse(localSort)
        this.pagination.sortBy = localSort.sortBy
        this.pagination.sortDesc = localSort.sortDesc
      }

      let { sortBy, descending, page, itemsPerPage } = this.pagination
      let query = this.$queryString(this.pagination, this.search_params)

      axios
        .get(this.url + "?" + query)
        .then((res) => {
          this.persons = res.data.data
          this.total = res.data.meta.total
          this.refresh = false
          this.show_loading = false

          this.pagination.page = res.data.meta.current_page
          this.pagination.itemsPerPage = Number(res.data.meta.per_page)
        })
        .catch((err) => console.log(err))
    },

    filter(target) {
      this.pagination.page = 1
      this.refresh = true
      localStorage.setItem("__filter_Person_List", JSON.stringify(this.search_params))
    },

    reset() {
      this.$refs.form.reset()
      this.pagination.page = 1
      this.refresh = true
    },

    del(id) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .delete(this.API_URL + "person/" + id)
            .then(() => {
              this.refresh = true
              vm.$awn.success(vm.$t("global.delete_success"))
            })
            .catch((err) => console.log(err))
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    }
  }
}
</script>

<style scoped></style>
